import * as React from 'react'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { getMonthShortNameByNumber } from '@/modules/drivers/hooks/useDateHelper'

export type ScheduleCalendarMonthsProps = {
  height: number
  width: number
  periods: Array<{ months: number; duration: string }>
}

export const ScheduleCalendarMonths: React.FC<ScheduleCalendarMonthsProps> = ({
  height,
  width,
  periods,
}) => {
  const { t } = useLocalize()

  const formatDuration = (duration: string): string => {
    if (!duration || duration === '00:00:00') return '00:00'

    const parts = duration.split('.')
    if (parts.length === 2) {
      const days = parseInt(parts[0], 10)
      const time = parts[1].split(':')
      const hours = parseInt(time[0], 10)
      const minutes = parseInt(time[1], 10)

      const totalHours = days * 24 + hours
      const formattedMinutes = minutes.toString().padStart(2, '0')

      return `${totalHours}:${formattedMinutes}`
    }

    return duration
  }

  const prepareMonths = (): Array<number> => {
    const header: Array<number> = []
    for (let i = 0; i < 12; i++) {
      header.push(i)
    }
    return header
  }

  const months = prepareMonths()

  return (
    <div className="tw-flex tw-flex-col tw-border-r tw-border-base-300">
      {months &&
        months.map((month, index) => {
          const periodData = periods && periods[index]
          const durationText = periodData
            ? formatDuration(periodData.duration)
            : '00:00'

          return (
            <div
              className="tw-ml-1.5 tw-flex tw-flex-col tw-gap-1.5 tw-border-b tw-border-base-300 tw-pt-1.5"
              key={index}
              style={{
                height: height,
                width: 56,
              }}
            >
              <span className="tw-text-xs tw-font-medium tw-text-content-base">
                {t(getMonthShortNameByNumber(month))}
              </span>
              <span className="tw-text-xs tw-font-medium tw-text-content-base/80">
                {durationText}
              </span>
            </div>
          )
        })}
    </div>
  )
}
